// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1GyJ2","inputWrap":"Table_inputWrap__3N2Ib","col":"Table_col__Ok-r1","bmiTooltip":"Table_bmiTooltip__xVlAh"};